module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "row large-centered modal-container",
    class: _vm.width
  }, [_c('div', {
    staticClass: "panel-title modal-title"
  }, [_vm._t("header", function() {
    return [_c('div', [_vm._v("\n              Default Header\n              ")])]
  }), _vm._v(" "), _c('hr')], 2), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_vm._t("body", function() {
    return [_vm._v("\n              default body\n            ")]
  }), _vm._v(" "), _c('hr')], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "modal-default-button",
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("\n                OK\n              ")])]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0d5c55c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/modal.vue
// module id = 805
// module chunks = 0